// extracted by mini-css-extract-plugin
export default {"component":"reload__Vx_1A","form":"reload__h65E0"};